import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const User = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0117 4.95848C11.0117 6.5924 9.68719 7.91696 8.05326 7.91696C6.41934 7.91696 5.09478 6.5924 5.09478 4.95848C5.09478 3.32456 6.41934 2 8.05326 2C9.68719 2 11.0117 3.32456 11.0117 4.95848ZM9.72142 4.95848C9.72142 5.87978 8.97456 6.62664 8.05326 6.62664C7.13196 6.62664 6.3851 5.87978 6.3851 4.95848C6.3851 4.03718 7.13196 3.29032 8.05326 3.29032C8.97456 3.29032 9.72142 4.03718 9.72142 4.95848Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.02785 8.93181C6.88648 8.93181 5.61084 9.16059 4.59167 9.81966C3.53714 10.5016 2.80634 11.6163 2.77263 13.2369C2.76397 13.6531 3.09896 14 3.51979 14H12.4802C12.9011 14 13.2359 13.6531 13.2274 13.2372C13.1946 11.6226 12.483 10.507 11.4406 9.82221C10.4336 9.16062 9.16931 8.93181 8.02785 8.93181ZM11.8879 12.7097H4.11348C4.26051 11.8456 4.70805 11.281 5.29234 10.9032C6.02859 10.4271 7.02887 10.2221 8.02785 10.2221C9.02675 10.2221 10.0112 10.427 10.7321 10.9006C11.3042 11.2764 11.7439 11.8408 11.8879 12.7097Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default User;
